import api from '../utils/api';
import qs from '../utils/qs';

export const getSchedules = async (data) => {
    try {
        const response = await api.post(`/fbpush/schedules/search`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getSchedulesById = async (params) => {
    try {
        const response = await api.get(`/fbpush/schedules/${params}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getSheduleById = async (id) => {
    try {
        const response = await api.get(`/fbpush/schedules/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const addShedule = async (data) => {
    try {
        const response = await api.post(`/fbpush/schedules`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const editSchedule = async (params, data) => {
    try {
        const response = await api.put(`/fbpush/schedules/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const deleteShedule = async (params) => {
    try {
        const response = await api.put(`/fbpush/schedules/status/${params}`, { status: 2 });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const scheduleStatusChange = async (params, data) => {
    try {
        const response = await api.put(`/fbpush/schedules/status/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}